import { useApi } from '@/shared/api/http';
import type { UserQueryParams } from '@/entities/user/model/types/user';

export const useUserService = () => {
  const api = useApi();

  const getUser = async (isAuth = true) => {
    try {
      return await api.get<any>('/user/self/', isAuth);
    } catch (error) {
      console.error('Ошибка при получении данных профиля:', error);
      throw error;
    }
  };

  const getUserFavoriteProducts = async (params: UserQueryParams, isAuth = true) => {
    try {
      return await api.get<any>('/user/favorite-products/', isAuth, {
        params,
      });
    } catch (error) {
      console.error('Ошибка при получении избранных товаров:', error);
      throw error;
    }
  };

  const updateUser = async (user: any, isAuth = true) => {
    try {
      return await api.patch<any>('/user/self/', user, isAuth);
    } catch (error) {
      console.error('Ошибка при обновлении данных профиля:', error);
      throw error;
    }
  };

  const getUserAddresses = async (isAuth = true) => {
    try {
      return await api.get<any>('/user/addresses/', isAuth);
    } catch (error) {
      console.error('Ошибка при получении адресов пользователя:', error);
      throw error;
    }
  };

  const addUserAddresses = async (address: any, isAuth = true) => {
    try {
      return await api.post<any>('/user/addresses/', isAuth, address);
    } catch (error) {
      console.error('Ошибка при добавлении адреса пользователя:', error);
      throw error;
    }
  };

  const updateUserAddress = async (addressId: string, address: any, isAuth = true) => {
    try {
      return await api.patch<any>(`/user/addresses/${addressId}/`, address, isAuth);
    } catch (error) {
      console.error('Ошибка при обновлении адреса пользователя:', error);
      throw error;
    }
  };

  const deleteUserAddress = async (addressId: string, isAuth = true) => {
    try {
      return await api.delete<any>(`/user/addresses/${addressId}/`, isAuth);
    } catch (error) {
      console.error('Ошибка при удалении адреса пользователя:', error);
      throw error;
    }
  };

  return {
    getUser,
    updateUser,
    getUserFavoriteProducts,
    getUserAddresses,
    addUserAddresses,
    updateUserAddress,
    deleteUserAddress,
  };
};
